'use strict';

var _classCallCheck = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/createClass");

var pull = require('pull-stream');

var isFunction = require('lodash.isfunction');

var assert = require('assert');

var select = require('../select');

var selectHandler = require('./select-handler');

var lsHandler = require('./ls-handler');

var matchExact = require('./match-exact');

var util = require('./../util');

var Connection = require('interface-connection').Connection;

var PROTOCOL_ID = require('./../constants').PROTOCOL_ID;
/**
 * Listener
 */


var Listener =
/*#__PURE__*/
function () {
  /**
   * Create a new Listener.
   */
  function Listener() {
    var _this = this;

    _classCallCheck(this, Listener);

    this.handlers = {
      ls: {
        handlerFunc: function handlerFunc(protocol, conn) {
          return lsHandler(_this, conn);
        },
        matchFunc: matchExact
      }
    };
    this.log = util.log.listener();
  }
  /**
   * Perform the multistream handshake.
   *
   * @param {Connection} rawConn - The connection on which
   * to perform the handshake.
   * @param {function(Error)} callback - Called when the handshake completed.
   * @returns {undefined}
   */


  _createClass(Listener, [{
    key: "handle",
    value: function handle(rawConn, callback) {
      var _this2 = this;

      this.log('listener handle conn');
      var selectStream = select(PROTOCOL_ID, function (err, conn) {
        if (err) {
          return callback(err);
        }

        var shConn = new Connection(conn, rawConn);
        var sh = selectHandler(shConn, _this2.handlers, _this2.log);
        pull(shConn, sh, shConn);
        callback();
      }, this.log);
      pull(rawConn, selectStream, rawConn);
    }
    /**
     * Handle a given `protocol`.
     *
     * @param {string} protocol - A string identifying the protocol.
     * @param {function(string, Connection)} handlerFunc - Will be called if there is a handshake performed on `protocol`.
     * @param {matchHandler} [matchFunc=matchExact]
     * @returns {undefined}
     */

  }, {
    key: "addHandler",
    value: function addHandler(protocol, handlerFunc, matchFunc) {
      this.log('adding handler: ' + protocol);
      assert(isFunction(handlerFunc), 'handler must be a function');

      if (this.handlers[protocol]) {
        this.log('overwriting handler for ' + protocol);
      }

      if (!matchFunc) {
        matchFunc = matchExact;
      }

      this.handlers[protocol] = {
        handlerFunc: handlerFunc,
        matchFunc: matchFunc
      };
    }
    /**
     * Receives a protocol and a callback and should
     * call `callback(err, result)` where `err` is if
     * there was a error on the matching function, and
     * `result` is a boolean that represents if a
     * match happened.
     *
     * @callback matchHandler
     * @param {string} myProtocol
     * @param {string} senderProtocol
     * @param {function(Error, boolean)} callback
     * @returns {undefined}
     */

  }]);

  return Listener;
}();

module.exports = Listener;